import { FolderType, } from '@models';
var UiFolderTreeBreadCrumbsComponent = /** @class */ (function () {
    function UiFolderTreeBreadCrumbsComponent() {
        this.showFolderIcon = false;
        this.FolderType = FolderType;
    }
    Object.defineProperty(UiFolderTreeBreadCrumbsComponent.prototype, "parentsTooltip", {
        get: function () {
            return this.parentNames.join(' / ') + ' /';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiFolderTreeBreadCrumbsComponent.prototype, "parentNames", {
        get: function () {
            if (!this.folder) {
                return [];
            }
            return this.folder.fullyQualifiedName.split('/').slice(0, -1);
        },
        enumerable: true,
        configurable: true
    });
    return UiFolderTreeBreadCrumbsComponent;
}());
export { UiFolderTreeBreadCrumbsComponent };
